// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__yf2zK","footer":"ReportModalFilter_footer__14sgr"};